import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemedIconComponent } from '../themed-icon/themed-icon.component';

export type SortDirection = 'asc' | 'desc';

@Component({
  selector: 'ocp-sortable-header',
  imports: [TranslatePipe, ThemedIconComponent],
  host: {
    role: 'columnheader',
    '[attr.aria-sort]': "active() ? (direction() === 'asc' ? 'ascending' : 'descending') : 'none'",
  },
  template: `
    <button
      type="button"
      class="sortable-header__btn"
      [class.sortable-header__btn--truncate]="truncate()"
      (click)="sort.emit()"
    >
      <span class="sortable-header__label" [class.sortable-header__label--truncate]="truncate()">
        {{ label() | translate }}
      </span>
      <span class="sortable-header__icon" [class.sortable-header__icon--active]="active()">
        <ocp-themed-icon
          [name]="direction() === 'desc' ? 'arrow-down.svg' : 'arrow-up.svg'"
          [size]="12"
        />
      </span>
    </button>
  `,
  styleUrl: './sortable-header.component.scss',
})
export class SortableHeaderComponent {
  readonly label = input.required<string>();
  readonly active = input(false);
  readonly direction = input<SortDirection>('asc');
  readonly truncate = input(true);
  readonly sort = output<void>();
}
